import { useOrientation } from '@/hooks';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { useFacilityStore } from '@/stores';
import { FACILITY_SEARCH_MODE } from '@/enums/facility';
import ShopFnbFacilitySearchModeButton from '@/components/common/shop-fnb-facility/buttons/search-mode';
import { getHSize } from '@/utils/size';
import useBaseSize from '@/hooks/useBaseSize';

interface FnbSearchControlProps {
    currentMode: FACILITY_SEARCH_MODE;
}

const FacilitySearchControl = ({ currentMode }: FnbSearchControlProps) => {
    const { t } = useTranslation();
    const { isHorizontal } = useOrientation();
    const { baseHeight } = useBaseSize();
    const setCurrentMode = useFacilityStore((state) => state.setCurrentMode);
    const updateFacilityContents = useFacilityStore((state) => state.updateFacilityContents);
    const resetFilters = useFacilityStore((state) => state.resetFilters);

    const handleChangeMode = (mode: FACILITY_SEARCH_MODE) => {
        resetFilters();
        setCurrentMode(mode);
        updateFacilityContents(mode);
    };

    return (
        <div
            className={clsx('flex w-full flex-col items-center')}
            style={{ gap: isHorizontal ? getHSize(8, baseHeight) : getHSize(12, baseHeight) }}
            data-region-nav
        >
            <ShopFnbFacilitySearchModeButton
                tabIndex={7}
                fullWidth
                role="radio"
                type="button"
                aria-label={t('fnb.search.tts.control_buttons.search_by_floor')}
                title={t('fnb.search.text.control_buttons.search_by_floor')}
                onClick={() => handleChangeMode(FACILITY_SEARCH_MODE.SEARCH_BY_FLOOR)}
                aria-checked={currentMode === FACILITY_SEARCH_MODE.SEARCH_BY_FLOOR}
                data-interactive
            />
            <ShopFnbFacilitySearchModeButton
                tabIndex={8}
                fullWidth
                role="radio"
                type="button"
                aria-label={t('fnb.search.tts.control_buttons.search_by_category')}
                title={t('fnb.search.text.control_buttons.search_by_category')}
                onClick={() => handleChangeMode(FACILITY_SEARCH_MODE.SEARCH_BY_CATEGORY)}
                aria-checked={currentMode === FACILITY_SEARCH_MODE.SEARCH_BY_CATEGORY}
                data-interactive
            />
        </div>
    );
};

export default FacilitySearchControl;
